import React from "react";

import { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "katex/dist/katex.min.css";
import "quill-emoji/dist/quill-emoji.css";
import { emojiToolbarHandler } from "quill-emoji";
import { Box, Typography } from "@mui/material";

const ReactQuillEditor = ({
  title,
  value,
  setValue,
  placeholder,
  error,
  helperText,
}) => {
  const quillRef = useRef(null);

  const modules = {
    toolbar: {
      container: [
        ["formula"],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["blockquote", "code-block"],
        ["link", "image"], // Include the video toolbar button
        ["clean"],
        ["emoji"],
      ],
      handlers: {
        emoji: emojiToolbarHandler,
      },
    },
    "emoji-toolbar": true,
    "emoji-textarea": false,
    "emoji-shortname": true,
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "blockquote",
    "code-block",
    "link",
    "image",
    "emoji",
  ];
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
      paddingBottom={1}
    >
      <Typography variant="subtitle1">{title}</Typography>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={setValue}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        className="quill-editor"
      />
      {error && (
        <Typography paddingX={2} variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default ReactQuillEditor;
